import { render, staticRenderFns } from "./companyDetailedViewComponent.vue?vue&type=template&id=a60f4358&"
import script from "./companyDetailedViewComponent.vue?vue&type=script&lang=js&"
export * from "./companyDetailedViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports